import { memo, useState } from 'react'
import styled from 'styled-components'
import Icon from '@/components/icon'
import { colors, fontSizes } from '@/styles'

const Wrapper = styled.button`
  display: inline-flex;
  align-items: center;
  background-color: ${colors.white};
  color: ${colors.regular};
  border-radius: 0;
  font-size: ${fontSizes.regular};
  height: 68px;
  line-height: 22px;
  cursor: pointer;
  outline: none;

  ${props =>
    !props.disabled &&
    `
    &:hover, &.selected {
      background-color: ${colors.secondary};
      color: ${colors.white};
    }
  `}

  ${props =>
    props.hasChildren &&
    `
    > .i {
      margin-right: 15px;
    }
  `}

  ${props =>
    props.align === 'center' &&
    `
    justify-content: center;
  `}

  ${props =>
    props.align === 'left' &&
    `
    text-align: left;
    justify-content: flex-start;
    padding-left: 7%;
  `}
`

const ImageButton = ({ children, iconProps, icon, activeIcon = '', ...rest }) => {
  const [hover, setHover] = useState(false)

  const getIconId = () => {
    if (!activeIcon) return icon
    if (rest['aria-checked']) return activeIcon
    return hover ? activeIcon : icon
  }

  return (
    <Wrapper
      hasChildren={!!children}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...rest}
    >
      {icon && <Icon id={getIconId()} className="i" {...iconProps} />}
      {children}
    </Wrapper>
  )
}

ImageButton.defaultProps = {
  align: 'center',
  type: 'button'
}

export default memo(ImageButton)
